// (B) 플레인 Badge — antd Badge 대체(순수 시각). `.om-badge` 래퍼 + `.om-badge-count` sup.
// 실측 소비처(UserMenu)는 children 위 count 배지만 사용. count 0/미지정 시 배지 미표시(antd 기본).
// overflowCount 초과 시 `N+` 표기(locale 무관 자체 처리). base 시각은 styles/omBadge.css.
import type { OmwBadgeProps } from '../api/OmwBadge'
import { cx } from './cx'
import '../styles/omwBadge.css'

export function PlainBadge({
  count,
  overflowCount = 99,
  className,
  style,
  children,
}: OmwBadgeProps) {
  const showCount = typeof count === 'number' && count > 0
  const display = showCount && count > overflowCount ? `${overflowCount}+` : count

  return (
    <span className={cx('om-badge', className)} style={style}>
      {children}
      {showCount && (
        <sup className="om-badge-count" title={String(count)}>
          {display}
        </sup>
      )}
    </span>
  )
}
